import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { FiSearch, FiPhone, FiUser, FiTrash2, FiEdit2, FiEye } from 'react-icons/fi';
import CallDetailModal from '../components/CallDetailModal';

const formatDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  const date = dt.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const time = dt.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true });
  return `${date} ${time}`;
};

const ContactsPage = () => {
  const { user } = useAuth();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactCalls, setContactCalls] = useState(null);
  const [editingContact, setEditingContact] = useState(null);
  const [editFirst, setEditFirst] = useState('');
  const [editLast, setEditLast] = useState('');
  const [selectedCall, setSelectedCall] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = search ? `?search=${encodeURIComponent(search)}` : '';
      const res = await api.get(`/contacts${params}`);
      setContacts(res.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [search]);

  useEffect(() => { load(); }, [load]);

  const handleCall = (n) => window.open(`https://ososenjaz.3cx.asia/#/people/phonedialog/${n}`, '_blank');

  const openProfile = async (contact) => {
    setSelectedContact(contact);
    try {
      const res = await api.get(`/calls?search=${encodeURIComponent(contact.phoneNumber)}&limit=100`);
      const calls = res.data.calls || [];
      // Check if any call is locked by another agent
      const lockedByOther = calls.some(c => c.followUpStatus === 'in_progress' && c.followUpByExtension !== user?.extension && user?.role !== 'admin');
      if (lockedByOther) { setSelectedContact(null); alert('هذا العميل محجوز من قبل موظف اخر'); return; }
      setContactCalls(calls);
    } catch (e) { setContactCalls([]); }
  };

  const startEdit = (c) => {
    setEditingContact(c);
    setEditFirst(c.firstName);
    setEditLast(c.lastName || '');
  };

  const saveEdit = async () => {
    if (!editFirst.trim()) return;
    try {
      await api.put(`/contacts/${editingContact.id}`, { firstName: editFirst.trim(), lastName: editLast.trim() });
      setEditingContact(null);
      load();
    } catch (e) { alert(e.response?.data?.error || 'حدث خطا'); }
  };

  const deleteContact = async (c) => {
    if (!window.confirm(`هل تريد حذف العميل ${c.firstName} ${c.lastName}؟ سيتم حذف الملف فقط وليس سجل المكالمات.`)) return;
    try {
      await api.delete(`/contacts/${c.id}`);
      setSelectedContact(null);
      load();
    } catch (e) { alert(e.response?.data?.error || 'حدث خطا'); }
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>العملاء</h2>
        <span style={{ color: '#666', fontSize: 13 }}>{contacts.length} عميل</span>
      </div>
      <div style={{ marginBottom: 16, position: 'relative' }}>
        <FiSearch style={{ position: 'absolute', right: 12, top: 12, color: '#999' }} />
        <input className="filter-input" placeholder="بحث بالاسم او الرقم..." value={search} onChange={e => setSearch(e.target.value)} style={{ width: '100%', paddingRight: 36 }} />
      </div>
      {loading ? (
        <div style={{ padding: 40, textAlign: 'center' }}>جاري التحميل...</div>
      ) : contacts.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#888', background: '#fff', borderRadius: 8 }}>{search ? 'لا توجد نتائج' : 'لا يوجد عملاء محفوظين بعد'}</div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
          <table className="data-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f9fafb' }}>
              <tr>
                <th style={{ padding: 12, textAlign: 'right' }}>الرقم</th>
                <th style={{ padding: 12, textAlign: 'right' }}>الاسم الاول</th>
                <th style={{ padding: 12, textAlign: 'right' }}>العائلة</th>
                <th style={{ padding: 12, textAlign: 'right' }}>اضافه بواسطة</th>
                <th style={{ padding: 12, textAlign: 'right' }}>تاريخ الاضافة</th>
                <th style={{ padding: 12, textAlign: 'right' }}>اجراء</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map(c => (
                <tr key={c.id} style={{ borderTop: '1px solid #eee' }}>
                  <td style={{ padding: 10, fontFamily: 'monospace', fontWeight: 600 }}>{c.phoneNumber}</td>
                  <td style={{ padding: 10 }}>{c.firstName}</td>
                  <td style={{ padding: 10 }}>{c.lastName || '-'}</td>
                  <td style={{ padding: 10, fontSize: 12, color: '#666' }}>{c.createdByName || '-'}</td>
                  <td style={{ padding: 10, fontSize: 12 }}>{formatDate(c.createdAt)}</td>
                  <td style={{ padding: 10 }}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      <button className="btn btn-call btn-sm" onClick={() => handleCall(c.phoneNumber)} title="اتصال"><FiPhone size={12} /></button>
                      <button className="btn btn-outline btn-sm" onClick={() => openProfile(c)} title="ملف العميل"><FiEye size={12} /></button>
                      <button className="btn btn-outline btn-sm" onClick={() => startEdit(c)} title="تعديل"><FiEdit2 size={12} /></button>
                      {user?.role === 'admin' && (
                        <button className="btn btn-outline btn-sm" style={{ color: '#dc2626' }} onClick={() => deleteContact(c)} title="حذف"><FiTrash2 size={12} /></button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {selectedContact && (
        <div className="modal-overlay" onClick={() => setSelectedContact(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 720, padding: 0, display: 'flex', flexDirection: 'column', maxHeight: '85vh' }}>
            <div style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 10, padding: '16px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <button className="modal-close" onClick={() => setSelectedContact(null)}>&times;</button>
              <h3 style={{ margin: 0 }}><FiUser style={{ marginLeft: 8 }} /> ملف العميل — {selectedContact.firstName} {selectedContact.lastName}</h3>
            </div>
            <div style={{ padding: 20, overflowY: 'auto' }}>
              <div style={{ background: '#f0f9ff', padding: 16, borderRadius: 8, marginBottom: 20 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  <div><strong>الرقم:</strong> {selectedContact.phoneNumber}</div>
                  <div><strong>الاسم:</strong> {selectedContact.firstName} {selectedContact.lastName}</div>
                  <div><strong>اضافه بواسطة:</strong> {selectedContact.createdByName || '-'}</div>
                  <div><strong>تاريخ الاضافة:</strong> {formatDate(selectedContact.createdAt)}</div>
                </div>
                <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                  <button className="btn btn-call btn-sm" onClick={() => handleCall(selectedContact.phoneNumber)}><FiPhone size={12} /> اتصال</button>
                  <button className="btn btn-outline btn-sm" onClick={() => startEdit(selectedContact)}><FiEdit2 size={12} /> تعديل</button>
                </div>
              </div>
              <h4 style={{ marginBottom: 12 }}>سجل المكالمات ({contactCalls ? contactCalls.length : '...'})</h4>
              {!contactCalls ? (
                <div style={{ textAlign: 'center', padding: 20 }}>جاري التحميل...</div>
              ) : contactCalls.length === 0 ? (
                <div style={{ textAlign: 'center', color: '#888', padding: 20 }}>لا توجد مكالمات</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {contactCalls.map(call => {
                    const isLocked = call.followUpStatus === 'in_progress';
                    const isMine = call.followUpByExtension === user?.extension;
                    const isAdmin = user?.role === 'admin';
                    const blocked = isLocked && !isMine && !isAdmin;
                    return (
                      <div key={call.id} style={{ background: isLocked ? '#fff8e1' : '#f9fafb', padding: 12, borderRadius: 6, border: '1px solid #eee' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div style={{ fontSize: 13 }}>
                            {blocked ? '*** محجوز ***' : (
                              <>
                                <span style={{ fontWeight: 600 }}>{formatDate(call.lastCallAt)}</span>
                                <span style={{ marginRight: 12, color: call.lastCallStatus === 'answered' ? '#059669' : '#dc2626' }}>
                                  {call.lastCallStatus === 'answered' ? 'مردود عليها' : 'فائتة'}
                                </span>
                                {call.answeredBy && <span style={{ color: '#666' }}> — {call.answeredBy}</span>}
                                {call.queueName && <span style={{ color: '#1565c0', marginRight: 8 }}>[{call.queueName}]</span>}
                              </>
                            )}
                          </div>
                          {!blocked && (
                            <button className="btn btn-outline btn-sm" onClick={() => setSelectedCall(call)} style={{ fontSize: 11 }}>
                              <FiEye size={10} /> تفاصيل
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {editingContact && (
        <div className="modal-overlay" onClick={() => setEditingContact(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 400, padding: 24 }}>
            <h3 style={{ marginTop: 0 }}>تعديل العميل</h3>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 600 }}>الاسم الاول *</label>
              <input value={editFirst} onChange={e => setEditFirst(e.target.value)} className="filter-input" style={{ width: '100%' }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13, fontWeight: 600 }}>اسم العائلة</label>
              <input value={editLast} onChange={e => setEditLast(e.target.value)} className="filter-input" style={{ width: '100%' }} />
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-primary" style={{ flex: 1 }} onClick={saveEdit}>حفظ</button>
              <button className="btn btn-outline" onClick={() => setEditingContact(null)}>الغاء</button>
            </div>
          </div>
        </div>
      )}
      {selectedCall && (
        <CallDetailModal call={selectedCall} onClose={() => setSelectedCall(null)} onUpdate={load} currentUser={user} />
      )}
    </div>
  );
};

export default ContactsPage;
